// extracted by mini-css-extract-plugin
export default {"auditNewDetail":"detail_auditNewDetail__ZzdpY","iframe":"detail_iframe__olz5i"};